// extracted by mini-css-extract-plugin
module.exports = {"currencyContainer":"InvoicesTable_currencyContainer__3ci59","tablePaymentScheduleDetail":"InvoicesTable_tablePaymentScheduleDetail__2GZos"};